import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { WorkflowService } from '../../_services/workflow.service';

// Model imports
import { WorkflowHistoryResultDto } from '../../../shared-workflow-module/_models/wfe-workflow-history-result-dto';
import { WorkFlowParametersDto } from '../../../shared-workflow-module/_models/workflow-parameters-dto';

@Component({
    selector: 'app-workflow-board-history',
    templateUrl: './workflow-board-history.component.html',
    styleUrls: ['./workflow-board-history.component.scss']
})
export class WorkflowBoardHistoryComponent implements OnInit {
    @ViewChild('workflowBoardHistoryPopup', { static: false }) workflowBoardHistoryPopup: DxPopupComponent;

    @Input() workflowId: number;
    @Input() communityId: number;

    @Output() onClose = new EventEmitter();

    visible = false;

    workflowBoardHistorySource: WorkflowHistoryResultDto[] = [];
    workflowBoardHistoryTitle: string;
    workflowBoardHistoryColumns: any[] = [];

    iconClose = IconConstants.CLOSE;

    loadingVisible = false;

    constructor(private readonly workflowService: WorkflowService, private readonly errorService: ServerErrorService) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
        this.setWorkflowBoardHistoryColumns();
        this.setWorkflowBoardTitle();
        this.getWorkflowBoardHistory();
    }

    onHistoryShown(): void {
        this.visible = true;
        this.workflowBoardHistoryPopup.instance.repaint();
    }

    onHistoryClose(): void {
        this.visible = false;
        this.onClose.emit();
    }

    private setWorkflowBoardHistoryColumns(): void {
        this.workflowBoardHistoryColumns = [
            {
                dataField: 'beginStep',
                dataType: 'string',
                caption: 'Begin Step'
            },
            {
                dataField: 'userAction',
                dataType: 'string',
                caption: 'Action'
            },
            {
                dataField: 'user.displayName',
                dataType: 'string',
                caption: 'User'
            },
            {
                dataField: 'actionedOn',
                dataType: 'date',
                caption: 'Date',
                cellTemplate: 'dateTemplate'
            }
        ];
    }

    private setWorkflowBoardTitle(): void {
        this.workflowBoardHistoryTitle = 'AAP Workflow Board History For # ' + this.workflowId;
    }

    private getWorkflowBoardHistory(): void {
        const baseParams: WorkFlowParametersDto = new WorkFlowParametersDto();
        baseParams.workflowId = this.workflowId;
        baseParams.communityId = this.communityId;

        this.loadingVisible = true;
        this.workflowService.getBoardHistory(baseParams).subscribe(
            (result: WorkflowHistoryResultDto[]) => {
                this.workflowBoardHistorySource = result;
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
